<template>
  <div>
    <template v-if="approvals?.length">
      <b-row
        v-for="(item, index) in approvals"
        :key="item._uid || index"
        class="mb-2"
      >
        <b-col md="11">
          <template v-if="!isDetail">
            <v-select
              id="approval_id"
              v-model="item.approval_id"
              :options="getAvailableApprovalOptions(index)"
              :reduce="(val) => val.value"
              label="text"
              placeholder="Select Approval"
              appen
              @input="(val) => onChangeApproval(index, val)"
            >
              <!-- Custom tampilan untuk setiap option -->
              <template #option="{ text, photo, position }">
                <div class="d-flex align-items-center">
                  <img
                    :src="photo || $getInitials(text)"
                    alt="avatar"
                    class="rounded-circle mr-2"
                    width="30"
                    height="30"
                  />
                  <div>
                    <div class="font-weight-bold">{{ text }}</div>
                    <small class="text-muted">{{ position }}</small>
                  </div>
                </div>
              </template>

              <!-- Custom tampilan untuk selected value -->
              <template #selected-option="{ text, photo }">
                <div class="d-flex align-items-center">
                  <img
                    :src="photo || $getInitials(text)"
                    alt="avatar"
                    class="rounded-circle mr-2"
                    width="25"
                    height="25"
                  />
                  <span>{{ text }}</span>
                </div>
              </template>
            </v-select>
          </template>
          <template v-else>
            <div class="d-flex align-items-center form-control-plaintext">
              <img
                :src="
                  getSelectedApprovalPhoto(item.approval_id) ||
                  $getInitials(getSelectedApprovalText(item.approval_id))
                "
                alt="avatar"
                class="rounded-circle mr-2"
                width="25"
                height="25"
              />
              <span>
                {{ getSelectedApprovalText(item.approval_id) || '-' }}
              </span>
            </div>
          </template>
        </b-col>
        <b-col v-if="!isDetail" md="1" class="px-0">
          <template v-if="index == 0">
            <b-button variant="primary" @click="addApproval">
              <i class="fas fa-plus"></i>
            </b-button>
          </template>
          <template v-else>
            <b-button variant="danger" @click="deleteApproval(index)">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </template>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    isDetail: Boolean,
    approvals: {
      type: Array,
      default: () => [],
    },
    approvalOptions: {
      type: Array,
      default: () => [],
    },
    profileId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {}
  },
  methods: {
    getAvailableApprovalOptions(currentIndex) {
      // Get array of already selected approval IDs, excluding the current item
      const selectedApprovalIds = this.approvals
        .map((approval, index) => {
          // Exclude current index to allow changing current selection
          if (index === currentIndex) return null
          return approval.approval_id
        })
        .filter((id) => id !== null && id !== undefined)

      // Filter out already selected approvals
      return this.approvalOptions.filter(
        (option) => !selectedApprovalIds.includes(option.value)
      )
    },
    emitApprovals() {
      // Emit salinan baru agar reaktivitas parent terpancing
      this.$emit(
        'update:approvals',
        this.approvals.map((a) => ({ ...a }))
      )
    },
    addApproval(userProfileId) {
      const newItem = {
        approval_id: userProfileId || null,
        _uid: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      }
      this.approvals.push(newItem)
      this.emitApprovals()
    },
    deleteApproval(index) {
      this.approvals.splice(index, 1)
      this.emitApprovals()
    },
    onChangeApproval(index, val) {
      // Pastikan assignment memicu reaktivitas dan emit ke parent
      this.$set
        ? this.$set(this.approvals[index], 'approval_id', val)
        : (this.approvals[index].approval_id = val)
      this.emitApprovals()
    },
    getSelectedApprovalText(approvalId) {
      const approval = this.approvalOptions.find(
        (opt) => opt.value === approvalId
      )
      return approval ? approval.text : ''
    },
    getSelectedApprovalPhoto(approvalId) {
      const approval = this.approvalOptions.find(
        (opt) => opt.value === approvalId
      )
      return approval ? approval.photo : ''
    },
  },
  mounted() {
    if (this.approvals.length === 0) {
      this.addApproval(this.profileId)
    }
  },
}
</script>

<style scoped>
/* Custom styling for v-select hover */
::v-deep .vs__dropdown-option--highlight {
  background-color: #f8f9fa !important;
  color: #495057 !important;
}

::v-deep .vs__dropdown-option:hover {
  background-color: #f8f9fa !important;
  color: #495057 !important;
}

::v-deep .vs__dropdown-option--highlight .font-weight-bold {
  color: #212529 !important;
}

::v-deep .vs__dropdown-option--highlight .text-muted {
  color: #6c757d !important;
}
</style>
